import React from 'react'
import loaderForPOS from '../../../assets/company/img/loader-for-pos.gif'

const Loader = () => {
  return (
    <div className="text-center position-relative" style={{height:"2rem"}}>
      <div className="d-flex justify-content-center">
        {/* <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
          </div> */}
        <img style={{width : '150px'}} src={loaderForPOS} alt="Loading..." />
      </div>
    </div>
  )
}

export default Loader